// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1X4wm","requiredAsterisk":"Info_requiredAsterisk__108Ac"};